import { ACCOUNT_CONTACT } from './byId';
import { ACCOUNT_CONTACTS } from './list';

import { CREATE_ACCOUNT_CONTACT } from './create';
import { UPDATE_ACCOUNT_CONTACT } from './update';
import { DELETE_ACCOUNT_CONTACT } from './delete';

export const accountContactApi = {
  byId: ACCOUNT_CONTACT,
  list: ACCOUNT_CONTACTS,
  create: CREATE_ACCOUNT_CONTACT,
  update: UPDATE_ACCOUNT_CONTACT,
  delete: DELETE_ACCOUNT_CONTACT,
};
